import { Theme } from '@mui/material/styles'

const gridContainerStyles = {
  alignItems: { xs: 'center', lg: 'flex-start' },
  textAlign: { xs: 'center', lg: 'left' },
  flexDirection: { xs: 'column-reverse', lg: 'row' },
}

const titleStyles = {
  color: (theme: Theme) => theme.palette.text.primary,
  fontSize: { xs: '24px', sm: '34px', lg: '48px' },
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: { xs: '32px', sm: '41.99px', lg: '56px' },
}

const subTitleStyles = {
  color: (theme: Theme) => theme.palette.text.primary,
  fontSize: { xs: '16px', sm: '20px', lg: '24px' },
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: { xs: '24px', sm: '32px' },
}

const imageStyles = {
  maxWidth: { xs: '270px', sm: '365px', lg: '540px' },
  width: '100%',
  height: 'auto',
}

export { subTitleStyles, titleStyles, gridContainerStyles, imageStyles }
